/**
 * SECRETELLES® — Qualité Européenne page brand logo fix.
 * Runs only on /pages/qualite-europeenne.
 * Extracted from theme.liquid to reduce global JS overhead.
 */
(function () {
  if (!/\/pages\/qualite-europeenne/.test(location.pathname)) return;

  var logos = {
    Axami: 'https://cdn.shopify.com/s/files/1/0800/7096/7625/files/axami_lingerie_brand.png?v=1709304876',
    Gorsenia: 'https://cdn.shopify.com/s/files/1/0800/7096/7625/files/gorsenia_lingerie_brand.png?v=1706429626',
    Gaia: 'https://cdn.shopify.com/s/files/1/0800/7096/7625/files/GAIA_LOGO_BRAND.png?v=1706463974',
    Kalimo: 'https://cdn.shopify.com/s/files/1/0800/7096/7625/files/kalimo_lingerie_brand.png?v=1706429626',
    Obsessive: 'https://cdn.shopify.com/s/files/1/0800/7096/7625/files/OBSESSIVE_BRAND_LOGO_NEW.png?v=1706814790',
    'Livia Corsetti': 'https://cdn.shopify.com/s/files/1/0800/7096/7625/files/Livia_Corsetti_Fashion_Logo.png?v=1706465194',
    Donna: 'https://cdn.shopify.com/s/files/1/0800/7096/7625/files/be_donna_lingerie_brand.png?v=1709304878',
    Dkaren: 'https://cdn.shopify.com/s/files/1/0800/7096/7625/files/dkaren_lingerie_brand.png?v=1706429613',
    Bicotone: 'https://cdn.shopify.com/s/files/1/0800/7096/7625/files/bicotone-logo-white-removebg-preview-2.png?v=1726656631',
    Stylove: 'https://cdn.shopify.com/s/files/1/0800/7096/7625/files/Stylove_logo_secretelles.png?v=1726657476',
  };

  function applyFix() {
    document.querySelectorAll('.se-europe-image-credits').forEach(function (el) {
      el.remove();
    });

    document.querySelectorAll('.se-eu-brands .brand-card').forEach(function (card) {
      card.style.border = '0';
      card.style.boxShadow = '0 14px 34px rgba(91,58,109,.07)';
      card.style.background = 'rgba(255,255,255,.86)';

      var title = card.querySelector('h5');
      if (!title) return;
      var name = title.textContent.trim();
      var logo = card.querySelector('.brand-logo');
      if (!logo) return;

      logo.style.border = '0';
      logo.style.background = 'transparent';
      logo.style.boxShadow = 'none';

      if (logos[name]) {
        logo.innerHTML =
          '<img src="' + logos[name] + '" alt="Logo ' + name + ' — SECRETELLES" ' +
          'loading="lazy" decoding="async" ' +
          'style="max-width:124px;max-height:58px;width:100%;height:100%;object-fit:contain;">';
      } else {
        logo.innerHTML =
          '<span style="font-family:Georgia,serif;font-size:20px;letter-spacing:2px;' +
          'color:#5B3A6D;text-transform:uppercase;line-height:1;">' + name + '</span>';
      }
    });

    var outline = document.querySelector('.se-eu-btn-outline');
    if (outline) outline.style.color = '#C9A86C';

    document.querySelectorAll('.se-europe .country-card .country-img img').forEach(function (img) {
      img.style.objectFit = 'cover';
      img.style.objectPosition = 'center center';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFix);
  } else {
    applyFix();
  }
})();
